/**
 * Marketing AI Tag 颜色映射 sessionStorage key（与 Opinion 区分）
 */
export const MARKETING_AI_TAG_COLOR_KEY = 'MARKETING_AI_TAG_COLOR';

/**
 * 指标列配置
 */
export const AdMetricColumns = [
  {
    key: 'impression_number',
    text: 'Impressions',
    maxKey: 'max_impression_number',
  },
  { key: 'view_count', text: 'Views', maxKey: 'max_view_count' },
  { key: 'like_count', text: 'Likes', maxKey: 'max_like_count' },
  { key: 'comment_count', text: 'Comments', maxKey: 'max_comment_count' },
  { key: 'share_count', text: 'Shares', maxKey: 'max_share_count' },
  // { key: 'interaction_count', text: 'Interactions', maxKey: 'max_interaction_count' },
  { key: 'days', text: 'Active Days' },
  // { key: 'material_count', text: 'Ad Count' },
];

export const ADSortOptions = [
  { text: 'First Seen-1', value: 'first_seen' },
  { text: 'Last Seen', value: 'last_seen' },
  ...AdMetricColumns.map(item => ({ text: item.text, value: item.key })),
];
